import { Component, OnInit, HostListener, Renderer2, Inject } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { TranslateService } from '@ngx-translate/core';
import { UtilsService } from '@services/index.service';
import { environment } from '@environments/environment';
import { DOCUMENT } from '@angular/common';

@Component({
  selector: 'app-certificates',
  templateUrl: './certificates.component.html',
  styleUrls: ['./certificates.component.scss'],
  standalone: false
})
export class CertificatesComponent implements OnInit {
  public theme = environment.THEME;
  public title: string = '';
  public pantResolution: number;
  public pantOrientation: string;

  constructor(
    private titleService: Title,
    public _utils: UtilsService,
    public translate: TranslateService,
    private renderer: Renderer2,
    @Inject(DOCUMENT) private document: Document
  ) {
    this.theme = this._utils.titleCaseWord(this.theme);
  }

  ngOnInit() {
    this.translate.get('CERTIFICATES.TITLE-PAGE').subscribe((res) => {
      this.titleService.setTitle(`${res} - ${this.theme}`);
      this.title = res;
    });

    this.pantResolution = window.innerWidth;
    this.setTabNavSeparator();

    this.pantOrientation = this.pantResolution > window.innerHeight ? 'Landscape' : 'Portrait';
  }

  @HostListener('window:resize', ['$event'])
  onResize() {
    this.pantResolution = window.innerWidth;
    this.setTabNavSeparator();
    this.pantOrientation = this.pantResolution > window.innerHeight ? 'Landscape' : 'Portrait';
  }

  private setTabNavSeparator() {
    const tabLabels = this.document.querySelectorAll('.mat-tab-label');
    const expansionPanels = this.document.querySelectorAll('.mat-expansion-panel-content');

    tabLabels.forEach(label => {
      this.renderer.setStyle(label, 'marginBottom', '2px');
    });

    expansionPanels.forEach(panel => {
      const parentPanel = panel.parentElement;
      if (parentPanel) {
        this.renderer.setStyle(parentPanel, 'marginBottom', '0px');
      }
    });
  }
}
